import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { useOnboardingDataLoader } from '@forwardflow/hooks/customHooks/onboarding'
import { OnboardingChrome } from '@forwardflow/layouts/OnboardingLayout'
import { OnboardingSteps } from '@forwardflow/modules/onboarding'
import { SaveConflictBanner } from '@forwardflow/modules/onboarding'
import { useOnboardingStoreV2 } from '@forwardflow/store'
import { SetupWizard } from '@forwardflow/features/onboarding-v2'

/**
 * `/onboarding`. One loader for the organization's setup record, then:
 * an agent gets the agent steps in the chrome they always had; a customer
 * gets setup v2 (`features/onboarding-v2`).
 */
export default function OnboardingPage() {
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const { isLoading, currentOrganization } = useOnboardingDataLoader(
      user?.email
   )
   const { isAgent } = useOnboardingStoreV2()

   if (isAgent)
      return (
         <OnboardingChrome
            user={user}
            isLoading={isLoading}
            currentOrganization={currentOrganization}
         >
            {/* Plan 261 — says so when this tab has stopped saving. */}
            <SaveConflictBanner />
            <OnboardingSteps />
         </OnboardingChrome>
      )

   return (
      <SetupWizard
         user={user}
         isLoading={isLoading}
         currentOrganization={currentOrganization}
      />
   )
}
